<template>
  <div class="image-banner f--c">
    <div v-if="imgList.length > 1" @click="handleDirection('left')">
      <i class="el-icon-arrow-left" :style="{ cursor: place <= 0 ? 'no-drop' : 'pointer' }"></i>
    </div>
    <div v-else style="width:31px"></div>
    <div class="image-box">
      <div class="img-list f--c" :style="{ marginLeft: `-${place * 60}px` }">
        <div class="img-item" v-for="(item, i) in imgList" :key="i">
          <el-popover placement="right" width="280" trigger="hover" popper-class="popper-img">
            <oss-img style="width:100%" :src="item" :width="240" mType="lfit" />
            <oss-img slot="reference" :src="item" :width="50" :height="60" />
          </el-popover>
        </div>
      </div>
    </div>
    <div v-if="imgList.length > 1" @click="handleDirection('right')">
      <i class="el-icon-arrow-right" :style="{ cursor: place >= imgList.length - 1 ? 'no-drop' : 'pointer' }"></i>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // imgList: [
      //   { src: 'https://img.kakaclo.com/image%2FFSZW23070%2FFSZW23070_PU_S_NUB%2F41ff11b6cdbd9fa5b97394f93eeb7a44.jpg?x-oss-process=image/resize,w_400,h_600,m_fill/format,webp' },
      //   { src: 'https://img.kakaclo.com/image%2FFSZW22635%2FFSZW22635_P_S_NUB%2Fd1ef8ed7b1cfb9b183b443b0415d774c.jpg?x-oss-process=image/resize,w_400,h_600,m_fill/format,webp' },
      //   { src: 'https://img.kakaclo.com/image%2FFSZW22476%2FFSZW22476_R_M_NUB%2F8d07ae9aa7252eb748065c2468cd1c9d.jpg?x-oss-process=image/resize,w_400,h_600,m_fill/format,webp' },
      //   { src: 'https://img.kakaclo.com/image%2FFSZW22403%2FFSZW22403_B_S_NUB%2Faa3babcd8f9af64ff138f618de760dd3.jpg?x-oss-process=image/resize,w_400,h_600,m_fill/format,webp' },
      //   { src: 'https://img.kakaclo.com/image%2FFSZW11929%2FFSZW11929_Y_S_NUB%2Fc4d8e7c726e31a1c652c81e58bd19904.jpg?x-oss-process=image/resize,w_400,h_600,m_fill/format,webp' }
      // ],
      place: 0
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    handleDirection(type) {
      if (type === 'left' && this.place > 0) {
        this.place--
      }
      if (type === 'right' && this.place < this.imgList.length - 1) {
        this.place++
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-banner {
  .image-box {
    width: 110px;
    height: 60px;
    overflow: hidden;
    margin: 0 6px;
    .img-list {
      position: relative;
      .img-item {
        width: 50px;
        height: 60px;
        margin-right: 10px;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  i {
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
